import { extractPrimaryCategoryFromParams } from "app/pages/industry-analysis/routes/routeUtils";
import categoryService from "app/common/services/categoryService";
import type { ICategory } from "app/common/services/categoryService.types";
import { AddToDashboard } from "app/components/dashboard/AddToDashboard/AddToDashboard";
import {
    INDUSTRY_FAMILY_NAME,
    SUPPORTED_CATEGORIES_WITH_SEGMENTS_METRICS,
} from "app/components/dashboard/widget-wizard/constants";
import type { IWidgetModelTypesWebSource } from "app/components/widget/widget-types/Widget";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

import { getSingleMetricConfig } from "../config/config";
import { useHighLevelMetricsContext } from "../context";

import { getCustomIndustryId } from "./helpers";

export const AddToDashboardWrapper = () => {
    const { selectedMetric, params, timeGranularity, queryParams, isPeriodOverPeriod } = useHighLevelMetricsContext();

    const safeSelectedMetric = selectedMetric || getSingleMetricConfig("monthly-visits");

    const defaultType = isPeriodOverPeriod ? "ComparedLine" : "Graph";

    const metric = safeSelectedMetric.metric;
    const family = INDUSTRY_FAMILY_NAME;
    const type = defaultType;

    const { webSource, includeSubdomains } = queryParams || {};
    const categoryParam = extractPrimaryCategoryFromParams(queryParams?.category || "");

    const categoryId = categoryService.categoryQueryParamToCategoryObject(categoryParam)?.id;
    const isCustomCategory = UserCustomCategoryService.isCustomCategory(categoryId || "");
    const categoryData: ICategory | undefined = isCustomCategory
        ? UserCustomCategoryService.getCustomAndSharedCategoryById(categoryParam?.slice(1) || "")
        : categoryService.getCategory(categoryId || "");

    const key = isCustomCategory
        ? {
              id: categoryData?.categoryId || "",
              name: categoryData?.name || "",
              category: categoryData?.categoryId || "",
          }
        : {
              id: `$${categoryData?.id || ""}`,
              name: categoryData?.text || "",
              category: `$${categoryData?.id || ""}`,
          };

    const customIndustryId = getCustomIndustryId(categoryParam || "");
    const isSegmentsAvailable = SUPPORTED_CATEGORIES_WITH_SEGMENTS_METRICS.includes(metric);

    const overrideAddToDashboardParams = {
        ...params,
        key: [key],
        family,
        ...(isSegmentsAvailable && { customIndustryId }),
    };

    const filters = {
        timeGranularity: timeGranularity?.value || "Monthly",
        includeSubDomains: Boolean(includeSubdomains) || true,
    };

    return (
        <AddToDashboard
            modelType="fromIndustry"
            webSource={(webSource || "Desktop") as IWidgetModelTypesWebSource}
            type={type}
            metric={metric}
            overrideAddToDashboardParams={overrideAddToDashboardParams}
            industryQueryParams={String(params?.category || "")}
            filters={filters}
        />
    );
};
